import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className, testid }) => (
    <motion.div
        className={className}
        data-testid={testid}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.95, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className }) => (
    <span className={`block overflow-hidden pb-[0.08em] ${className || ""}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </span>
);

export const Marquee = ({ items, duration = 55, className }) => {
    const row = (
        <>
            {items.map((item, i) => (
                <span key={i} className="flex items-center shrink-0">
                    <span className="font-display italic text-2xl sm:text-3xl text-[#FAF7F2]/90 px-6 sm:px-10 whitespace-nowrap">
                        {item}
                    </span>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4A359] shrink-0" />
                </span>
            ))}
        </>
    );
    return (
        <div data-testid="editorial-marquee" className={`overflow-hidden ${className || ""}`} aria-hidden="true">
            <div className="marquee-track flex w-max" style={{ animationDuration: `${duration}s` }}>
                <div className="flex">{row}</div>
                <div className="flex">{row}</div>
            </div>
        </div>
    );
};

export const ParallaxImage = ({ src, alt, className, imgClassName, amount = 12 }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], [`-${amount}%`, `${amount}%`]);
    return (
        <div ref={ref} className={`overflow-hidden ${className || ""}`}>
            <motion.img
                src={src}
                alt={alt}
                loading="lazy"
                style={{ y }}
                className={`w-full h-[130%] -mt-[15%] object-cover will-change-transform ${imgClassName || ""}`}
            />
        </div>
    );
};

export const MagneticHover = ({ children, className }) => (
    <motion.div
        className={className}
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.97 }}
        transition={{ type: "spring", stiffness: 320, damping: 22 }}
    >
        {children}
    </motion.div>
);
